<template>
    <small>    
        <b-overlay :show="!items">
            <b-table :fields="fields" :items="items" small bordered table-class="small-text print-table" class="mb-0" show-empty>
                <template #empty>
                    <div class="text-center my-2 fs-5">
                        No hay documentos que coincidan con los criterios de búsqueda
                    </div>
                </template>

                <template #cell(rolesDestinations)="data">
                    <div class="assistants-container">
                        <div>
                            <ul class="minimal-list">
                                <li v-for="(dest) in data.item.rolesDestinations" :key="dest.id">
                                    <small>{{ dest.name }}</small>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
                <template #cell(visitors)="data">
                    <div class="assistants-container">
                        <div>
                            <ul class="minimal-list">
                                <li v-for="(visitor) in data.item.visitors" :key="visitor.id">
                                    <small>{{formatVisitor(visitor)}}</small>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
                <template #cell(nonVisitors)="data">
                    <div class="assistants-container">
                        <div>
                            <ul class="minimal-list">
                                <li v-for="(item, index) in data.item.nonVisitors" :key="index">
                                    <small>{{item.visitorMail}}</small>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
                <template #cell(details)="data">
                    <div>
                        <b>Tipo de documento:</b> {{ data.item.type.name }}
                        <br>
                        <b>Fecha de creación</b>: {{ formatDateTime(data.item.creationDate) }}
                        <br>
                        <b>Confidencial:</b> {{ formatBoolean(data.item.confidential) }}
                    </div>
                </template>
            </b-table>
        </b-overlay>
    </small>
</template>

<script>
import { formatBoolean, formatDateTime, formatVisitor } from '@/plugins/complianceScripts';

export default {
    name: 'DocumentReportTable',

    props: {
        items: Array,
    },

    data() {
        return {
            fields: [
                { key: 'name', label: 'Documento', thClass: "text-center col-2", tdClass: "align-middle text-center" },
                { key: 'rolesDestinations', label: 'Destinatarios', thClass: "text-center col-2" },
                { key: 'details', label: 'Detalles', thClass: "text-center col-4"},
                { key: 'visitors', label: 'Visitantes', thClass: "text-center col-2" },
                { key: 'nonVisitors', label: 'Correos sin visualizar', thClass: "text-center col-2" },
            ]
        }
    },

    methods: {
        formatVisitor,
        formatDateTime,
        formatBoolean
    }
}
</script>

<style scoped>
.assistants-container {
    text-align: left;
}

.minimal-list {
    list-style: none;
    padding-left: 0.2rem;
    margin: 0.2rem 0;
    padding-left: 1em;
}

.minimal-list li::before {
    content: "- ";
    display: inline-block;
    width: 1em;
    margin-left: -1em;
}

.small-text {
    font-size: 0.875em;
}

.small-text th {
    font-size: 0.875em;
    font-weight: bold;
}

</style>
